var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('h5',{staticClass:"pageTitle"},[_vm._v("Liste des conférences")]),_c('conferences-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }